export default "__VITE_ASSET__Bf_fdMMX__"